<wl-hero
  [id]="id()"
  [hero]="hero()"
  [hasWidget]="hasWidget()"
  [hasAsset]="hasAsset()"
  [hasBreadcrumbs]="hasBreadcrumbs()"
  [hasEssentRebranding]="enableEssentRebranding"
/>
